var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-by-cabin"},[_c('b-form-select',{attrs:{"options":_vm.cabin_options,"value-field":"value","text-field":"text"},on:{"change":_vm.handle_change},model:{value:(_vm.cabin),callback:function ($$v) {_vm.cabin=$$v},expression:"cabin"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }